import React from "react";
import { AuthProvider, useAuth } from "@/lib/state/authState";
import { WorkspaceProvider, useWorkspace } from "@/lib/state/workspaceState";
import { UiProvider, useUi } from "@/lib/state/uiState";
import { TutorialProvider } from "@/features/tutorial/TutorialContext";

export function AppProvider({ children }) {
  return (
    <AuthProvider>
      <WorkspaceProvider>
        <UiProvider>
          <TutorialProvider>{children}</TutorialProvider>
        </UiProvider>
      </WorkspaceProvider>
    </AuthProvider>
  );
}

export function useApp() {
  return {
    ...useAuth(),
    ...useWorkspace(),
    ...useUi(),
  };
}

export { useAuth } from "@/lib/state/authState";
export { useWorkspace } from "@/lib/state/workspaceState";
export { useUi } from "@/lib/state/uiState";
